import { Navigate, Outlet } from 'react-router-dom';

import { useMatchCurrentPage } from '@/hooks/useMatchCurrentPage';
import { usePathSet } from '@/hooks/usePathSet';
import { useDisplayUploadsPage } from '@/pages/shared/uploads/hooks/useDisplayUploadsPage';

export const UploadsProtection = () => {
  const pathSet = usePathSet();
  const isUploadsPage = useMatchCurrentPage([
    pathSet.uploads,
    pathSet.uploadsPlotOverview,
    pathSet.uploadsPlotOverviewPlot,
    pathSet.insituDataUpload,
    pathSet.mediaMaps,
    pathSet.mediaMapsConfiguration,
  ]);
  const hasUploadsPageAccess = useDisplayUploadsPage();

  if (isUploadsPage && !hasUploadsPageAccess) {
    return <Navigate to={pathSet.home} replace />;
  }

  return <Outlet />;
};
